import Botpoison from "@botpoison/browser";

export default class AjaxForm {

	constructor() {

		this.debugMode = WP.env !== 'production';

		// set default hooks
		this.beforeAjax = () => {};
		this.afterAjax = () => {};
		this.onReady = () => {};
		this.onError = () => {};
		this.onSuccess = () => {};
	}

	async checkBotpoison() {

		this.debug(`Starting botpoison challenge...`);
		
		const botpoison = new Botpoison({
			publicKey: window.botpoisonConfig.publicKey,
		});
		
		const { solution } = await botpoison.challenge();
		
		this.$form.append(`<input type="hidden" name="_botpoison" value="${solution}" />`);

		this.debug(`Botpoison challenge completed!`);
	}

	debug(...message) {
		if (!this.debugMode) return;
			
		if (message.length > 1) {
			console.log('AjaxForm:', ...message);
		} else {
			console.log('AjaxForm:', message[0]);
		}
	}

	async submit(event) {

		if (event) {
			event.preventDefault();
		}

		// fire before hook
		this.beforeAjax();

		// check botpoison (if enabled)
		if (this.$form.get(0).hasAttribute('data-botpoison')) {
			await this.checkBotpoison();
		}

		const formData = this.$form.serializeArray();
		const url = WP.ajax_url;
		const data = $.param(formData);
		const method = this.$form.attr('method');

		this.debug('Sending data', { formData, url, data, method });

		const jqXHR = $.ajax({ url, data, method });

		jqXHR.done(response => {
			
			// handle error from server
			if (!response.success) {

				this.debug('Error', { response });

				// fire error hook
				this.onError(response.data);

				return false;
			}

			this.debug('Success', { response });

			// fire success hook
			this.onSuccess(response.data);
		});
		
		jqXHR.fail(response => {

			this.debug('Error', { response });

			// fire error hook
			this.onError(response.data);
		});
		
		jqXHR.always(response => {

			// fire after hook
			this.afterAjax(response);
		});
	}

	init(form) {
		this.$form = $(form);
		this.$submitButton = this.$form.find('button[type="submit"]');

		this.$form.on('submit', this.submit.bind(this));

		// fire ready hook
		this.onReady();

		this.debug('Initialized');
	}
}